<template>
  <div>
    <v-btn @click.native.stop.prevent="toggleItemFromWishList" icon fab right absolute class="toggle-wishlist-item-btn">
      <v-icon size="23" color="secondary">{{ btnIcon }}</v-icon>
    </v-btn>
    <RemoveItemFromWishListModal v-if="wishlistItem" :key="wishlistItem.id" :isModalOpen="isModalOpen" :itemId="wishlistItem.id" @close-modal="toggleModal" />
  </div>
</template>

<script>
  import RemoveItemFromWishListModal from "./RemoveItemFromWishListModal";

  export default {
    name: "ToggleWishListItemIcon",

    props: {
      productId: {
        required: true,
      },
    },

    data() {
      return {
        isModalOpen: false,
      };
    },

    components: {
      RemoveItemFromWishListModal,
    },

    computed: {
      wishlistItem() {
        return this.$store.getters.findWishByProductId(this.productId);
      },
      isItemInWishList() {
        return !this.$validator.isEmpty(this.wishlistItem);
      },
      btnIcon() {
        return this.isItemInWishList ? "fas fa-heart" : "far fa-heart";
      },
    },

    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      addWish() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .post("/wishes", { wish: { product_id: this.productId } })
          .then((response) => {
            this.$store.commit("addWish", response.data.wish);

            this.$store.commit("setError", {
              message: "Added the product to your wish list",
              type: "success",
            });
            this.$store.commit("setLoadingStatus", false);
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("setError", {
              message: "Failed to add the product to your wish list",
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },

      toggleItemFromWishList() {
        this.isItemInWishList ? this.toggleModal() : this.addWish();
      },
    },
  };
</script>

<style scoped>
  .toggle-wishlist-item-btn {
    right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/WishList/ToggleWishListItemIcon.vue